import API from '../api/myco'

const POLL_INTERVAL_MS = 30000

let pollTimer = null
let visibilityHandler = null
let storeRef = null
let routerRef = null
let pollingInitialized = false
const knownIds = new Set()

export function requestDesktopNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return Promise.resolve('unsupported')
  }
  if (Notification.permission === 'granted' || Notification.permission === 'denied') {
    return Promise.resolve(Notification.permission)
  }
  return Notification.requestPermission()
}

export function startNotificationPolling(store, router) {
  stopNotificationPolling()
  storeRef = store
  routerRef = router
  pollingInitialized = false
  knownIds.clear()

  const poll = async () => {
    if (!storeRef?.state?.user) return
    try {
      const { notifications, reminders } = await storeRef.dispatch('refreshNotifications')
      handleNewItems(notifications, 'notification')
      handleNewItems(reminders, 'reminder')
      pollingInitialized = true
    } catch {
      /* ignore transient poll failures */
    }
  }

  poll()
  pollTimer = setInterval(poll, POLL_INTERVAL_MS)

  visibilityHandler = () => {
    if (document.visibilityState === 'visible') {
      poll()
    }
  }
  document.addEventListener('visibilitychange', visibilityHandler)
}

export function stopNotificationPolling() {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
  if (visibilityHandler) {
    document.removeEventListener('visibilitychange', visibilityHandler)
    visibilityHandler = null
  }
  storeRef = null
  routerRef = null
  pollingInitialized = false
  knownIds.clear()
}

function handleNewItems(items, kind) {
  if (!Array.isArray(items)) return
  for (const item of items) {
    if (!item?.id) continue
    if (item.status === 'read') {
      knownIds.add(item.id)
      continue
    }
    if (knownIds.has(item.id)) continue
    knownIds.add(item.id)
    if (pollingInitialized) {
      showDesktopNotification(item, kind)
    }
  }
}

function showDesktopNotification(item, kind) {
  if (typeof window === 'undefined' || !('Notification' in window)) return
  if (Notification.permission !== 'granted') return
  if (!document.hidden) return

  const isReminder = kind === 'reminder'
  const title = isReminder ? 'MyCo+ Reminder' : 'MyCo+ Notification'
  const body = item.message || item.category || 'You have a new update.'
  const route = isReminder ? '/reminders' : '/notifications'

  try {
    const notification = new Notification(title, {
      body,
      tag: `${kind}-${item.id}`,
      icon: '/favicon.ico',
    })
    notification.onclick = () => {
      window.focus()
      if (routerRef) {
        routerRef.push(route)
      } else {
        window.location.assign(route)
      }
      notification.close()
    }
  } catch {
    /* browser blocked or unsupported context */
  }
}
